<template>
  <div class="multimedia__content-grid">
    <chat-multimedia-empty
      v-if="isEmpty"
      :tab="$t('multimedia.images')"
      :campaign="selectedCampaignName"
    />
    <div v-else>
      <div class="multimedia__campaign" v-if="isHistory">
        <span>
          {{ $t("multimedia.tab-from", { tab: $t("multimedia.images") }) }}
        </span>
        <span class="multimedia__campaign-name"
          >{{ selectedCampaignName }}
        </span>
      </div>
      <div class="grid-x grid-margin-x grid-margin-y">
        <div
          v-for="(image, index) in imagesList"
          :key="index"
          class="cell small-12 medium-6 large-4"
        >
          <multimedia-image @selected="selectElement" :image="image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MultimediaImage from '@/components/multimedia/items/Image.vue';

export default {
  components: {
    MultimediaImage,
    ChatMultimediaEmpty: () => import('@/components/ChatMultimediaEmpty.vue'),
  },
  props: {
    selectedCampaign: {
      type: [String, null],
    },
    selectedCampaignName: {
      type: [String, null],
    },
  },
  computed: {
    ...mapGetters([
      'activeConversation',
      'activeConversationHistory',
      'dataBankImages',
    ]),
    conversation() {
      return !this.isHistory
        ? this.activeConversation.conversation
        : this.activeConversationHistory.conversation;
    },
    campaignId() {
      return this.conversation.campaign.id;
    },
    imagesList() {
      return this.dataBankImages({
        campaignId: this.selectedCampaign,
      });
    },
    isEmpty() {
      return this.imagesList.length === 0;
    },
  },
  methods: {
    selectElement(image) {
      this.$emit('data-bank-picked', image);
    },
  },
};
</script>
